import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import MfstitchingstatusDashboard from '../MfstitchingstatusDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function MfstitchingstatusPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < MfstitchingstatusDashboard />
    )

}